export function isSubdomainRedirectNeeded(subdomain?: string): boolean {
  if (!subdomain) {
    return false;
  }

  const hostSplit = window.location.host.split('.');
  const canChangeSubdomain = hostSplit.length >= 2;
  const subdomainFromUrl = hostSplit.length >= 3 ? hostSplit[0] : undefined;

  return canChangeSubdomain && subdomainFromUrl !== subdomain;
}
